@if (laboratory) {
  <div>
    <div id="title--container">
      <h4>New Calibration Setup</h4>
      <h5>{{ laboratory.laboratoryName }}</h5>
    </div>
    <hr aria-hidden="true" />
    <div id="new-calibration--container">
      @if (displayFormFields) {
        <div class="card">
          <div class="header">
            <div class="card-title">Calibration Details</div>
          </div>
          <hr class="card-divider" aria-hidden="true" />
          <div class="content">
            <div class="selection-chips">
              <app-chip-radio-button
                [field]="setupField"
                [parentForm]="calibrationForm"
                [currentValue]="calibrationForm?.controls[setupField.key]?.value"
              ></app-chip-radio-button>
              <app-chip-radio-button
                [field]="calibrationTypeField"
                [parentForm]="calibrationForm"
                [currentValue]="calibrationForm?.controls[calibrationTypeField.key]?.value"
              ></app-chip-radio-button>
            </div>
            <div class="form-field--container">
              <div>
                @if (!devicesLoading && deviceList?.length > 0) {
                  <app-underlined-dropdown-form-field
                    [parentForm]="calibrationForm"
                    [field]="deviceField"
                  ></app-underlined-dropdown-form-field>
                }
                @if (
                  !devicesLoading && (!deviceList || deviceList.length === 0)
                ) {
                  <span class="body1">No devices available</span>
                }
                @if (devicesLoading) {
                  <div>
                    <app-small-loading-spinner></app-small-loading-spinner>
                  </div>
                }
              </div>
              <app-underlined-form-field
                [parentForm]="calibrationForm"
                [field]="calibrationNameField"
              ></app-underlined-form-field>
              @if (!saveLocationsLoading) {
                <div>
                  @if (slotList?.length > 0) {
                    <app-underlined-dropdown-form-field
                      [parentForm]="calibrationForm"
                      [field]="saveLocationField"
                    ></app-underlined-dropdown-form-field>
                  }
                  @if (!slotList) {
                    <span class="body1">No save locations reported</span>
                  }
                  @if (slotList?.length === 0) {
                    <span class="body1"
                      >Select a device to view save locations</span
                    >
                  }
                </div>
              } @else {
                <app-small-loading-spinner></app-small-loading-spinner>
              }
              @if (calibrationModuleType === ModuleEnum.pH) {
                <div>
                  <app-number-form-field
                    [parentForm]="pHForm"
                    [field]="temperatureField"
                    [minValue]="minTemperaturePH"
                    [maxValue]="maxTemperaturePH"
                    [step]="tempStep"
                  ></app-number-form-field>
                </div>
              }
              @if (
                calibrationModuleType === ModuleEnum.Sparging &&
                !isManualCalibration
              ) {
                <div>
                  <app-number-form-field
                    [parentForm]="spargingForm"
                    [field]="volumeField"
                    [minValue]="minVolume"
                    [maxValue]="maxVolume"
                    [step]="volumeStep"
                  ></app-number-form-field>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="card">
          <div class="header">
            <div class="card-title">Calibration Parameters</div>
          </div>
          <hr class="card-divider" aria-hidden="true" />
          <div class="content">
            @if (
              (calibrationModuleType === ModuleEnum.BaseModule ||
                calibrationModuleType === ModuleEnum.Oxygen) &&
              !isManualCalibration
            ) {
              <div class="form-field--container temp">
                <div class="temp-pair">
                  <app-slide-toggle
                    [parentForm]="temperatureValuesForm"
                    [field]="temperatureControlAField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="temperatureValuesForm"
                    [field]="inputTemperatureAField"
                    [minValue]="minTemperatureODAndOxygen"
                    [maxValue]="maxTemperatureODAndOxygen"
                    [step]="temperatureStepOD"
                  ></app-number-form-field>
                </div>
                <div class="temp-pair">
                  <app-slide-toggle
                    [parentForm]="temperatureValuesForm"
                    [field]="temperatureControlBField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="temperatureValuesForm"
                    [field]="inputTemperatureBField"
                    [minValue]="minTemperatureODAndOxygen"
                    [maxValue]="maxTemperatureODAndOxygen"
                    [step]="temperatureStepOD"
                  ></app-number-form-field>
                </div>
                <div class="temp-pair">
                  <app-slide-toggle
                    [parentForm]="temperatureValuesForm"
                    [field]="temperatureControlCField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="temperatureValuesForm"
                    [field]="inputTemperatureCField"
                    [minValue]="minTemperatureODAndOxygen"
                    [maxValue]="maxTemperatureODAndOxygen"
                    [step]="temperatureStepOD"
                  ></app-number-form-field>
                </div>
                <div class="temp-pair">
                  <app-slide-toggle
                    [parentForm]="temperatureValuesForm"
                    [field]="temperatureControlDField"
                  ></app-slide-toggle>
                  <app-number-form-field
                    [parentForm]="temperatureValuesForm"
                    [field]="inputTemperatureDField"
                    [minValue]="minTemperatureODAndOxygen"
                    [maxValue]="maxTemperatureODAndOxygen"
                    [step]="temperatureStepOD"
                  ></app-number-form-field>
                </div>
              </div>
            }
            @if (
              calibrationModuleType === ModuleEnum.pH && !isManualCalibration
            ) {
              <h6>Add 2-5 buffers</h6>
              <div class="form-field--container">
                <app-underlined-dropdown-form-field
                  [parentForm]="pHForm"
                  [field]="pHBuffer1Field"
                ></app-underlined-dropdown-form-field>
                <app-underlined-dropdown-form-field
                  [parentForm]="pHForm"
                  [field]="pHBuffer2Field"
                ></app-underlined-dropdown-form-field>
                <app-underlined-dropdown-form-field
                  [parentForm]="pHForm"
                  [field]="pHBuffer3Field"
                ></app-underlined-dropdown-form-field>
                <app-underlined-dropdown-form-field
                  [parentForm]="pHForm"
                  [field]="pHBuffer4Field"
                ></app-underlined-dropdown-form-field>
                <app-underlined-dropdown-form-field
                  [parentForm]="pHForm"
                  [field]="pHBuffer5Field"
                ></app-underlined-dropdown-form-field>
              </div>
            }
            @if (isManualCalibration) {
              @if (calibrationModuleType === ModuleEnum.Oxygen) {
                <div class="toggle--container">
                  <app-slide-toggle
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="is100PercentField"
                  ></app-slide-toggle>
                  <app-slide-toggle
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="isZeroPercentField"
                  ></app-slide-toggle>
                </div>
                <div id="nav--container">
                  <app-alt-option-tab-toggle
                    id="oxygen-toggle--container"
                    groupName="navigationToggle"
                    [selectOptions]="navOptions"
                    type="round"
                    [(currentValue)]="selectedTabOption"
                  >
                  </app-alt-option-tab-toggle>
                </div>
              }
              <h6>Flask A</h6>
              <div class="manual-form-fields">
                @if (calibrationModuleType === ModuleEnum.BaseModule) {
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="offsetAField"
                    [minValue]="odOffsetMin"
                    [maxValue]="odOffsetMax"
                    [step]="odOffsetStep"
                    [showWarning]="manualODF.offsetA.value < odBelowRangeWarning"
                    [warningMessage]="odBelowRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="factorAField"
                    [minValue]="odFactorMin"
                    [maxValue]="odFactorMax"
                    [step]="odFactorStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="powerAField"
                    [minValue]="odPowerMin"
                    [maxValue]="odPowerMax"
                    [step]="odPowerStep"
                    [showWarning]="
                      manualODF.powerA.value > odPowerAboveRangeWarning
                    "
                    [warningMessage]="odPowerAboveRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="temperatureAField"
                    [minValue]="odTemperatureMin"
                    [maxValue]="odTemperatureMax"
                    [step]="odTemperatureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "100"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi100AField"
                    [minValue]="oxygenDphi100Min"
                    [maxValue]="oxygenDphi100Max"
                    [step]="oxygenDphi100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature100AField"
                    [minValue]="oxygenTemp100Min"
                    [maxValue]="oxygenTemp100Max"
                    [step]="oxygenTemp100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="pressure100AField"
                    [minValue]="oxygenPressureMin"
                    [maxValue]="oxygenPressureMax"
                    [step]="oxygenPressureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "0"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi0AField"
                    [minValue]="oxygenDphi0Min"
                    [maxValue]="oxygenDphi0Max"
                    [step]="oxygenDphi0Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature0AField"
                    [minValue]="oxygenTemp0Min"
                    [maxValue]="oxygenTemp0Max"
                    [step]="oxygenTemp0Step"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.pH) {
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phSlopeAField"
                    [minValue]="phSlopeMin"
                    [maxValue]="phSlopeMax"
                    [step]="phSlopeStep"
                    [showWarning]="
                      manualPHF.slopeA.value < phSlopeBelowRangeWarning ||
                      manualPHF.slopeA.value > phSlopeAboveRangeWarning
                    "
                    [warningMessage]="phSlopeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phOffsetAField"
                    [minValue]="phOffsetMin"
                    [maxValue]="phOffsetMax"
                    [step]="phOffsetStep"
                    [showWarning]="manualPHF.offsetA.value < phBelowRangeWarning"
                    [warningMessage]="phBelowRangeWarningMessage"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.Sparging) {
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="spargingSlopeAField"
                    [minValue]="spargingSlopeMin"
                    [maxValue]="spargingSlopeMax"
                    [step]="spargingSlopeStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="interceptAField"
                    [minValue]="spargingInterceptMin"
                    [maxValue]="spargingInterceptMax"
                    [step]="spargingInterceptStep"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType !== ModuleEnum.Oxygen) {
                  <p>R2: 1</p>
                }
              </div>
              <h6>Flask B</h6>
              <div class="manual-form-fields">
                @if (calibrationModuleType === ModuleEnum.BaseModule) {
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="offsetBField"
                    [minValue]="odOffsetMin"
                    [maxValue]="odOffsetMax"
                    [step]="odOffsetStep"
                    [showWarning]="manualODF.offsetB.value < odBelowRangeWarning"
                    [warningMessage]="odBelowRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="factorBField"
                    [minValue]="odFactorMin"
                    [maxValue]="odFactorMax"
                    [step]="odFactorStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="powerBField"
                    [minValue]="odPowerMin"
                    [maxValue]="odPowerMax"
                    [step]="odPowerStep"
                    [showWarning]="
                      manualODF.powerB.value > odPowerAboveRangeWarning
                    "
                    [warningMessage]="odPowerAboveRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="temperatureBField"
                    [minValue]="odTemperatureMin"
                    [maxValue]="odTemperatureMax"
                    [step]="odTemperatureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "100"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi100BField"
                    [minValue]="oxygenDphi100Min"
                    [maxValue]="oxygenDphi100Max"
                    [step]="oxygenDphi100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature100BField"
                    [minValue]="oxygenTemp100Min"
                    [maxValue]="oxygenTemp100Max"
                    [step]="oxygenTemp100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="pressure100BField"
                    [minValue]="oxygenPressureMin"
                    [maxValue]="oxygenPressureMax"
                    [step]="oxygenPressureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "0"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi0BField"
                    [minValue]="oxygenDphi0Min"
                    [maxValue]="oxygenDphi0Max"
                    [step]="oxygenDphi0Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature0BField"
                    [minValue]="oxygenTemp0Min"
                    [maxValue]="oxygenTemp0Max"
                    [step]="oxygenTemp0Step"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.pH) {
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phSlopeBField"
                    [minValue]="phSlopeMin"
                    [maxValue]="phSlopeMax"
                    [step]="phSlopeStep"
                    [showWarning]="
                      manualPHF.slopeB.value < phSlopeBelowRangeWarning ||
                      manualPHF.slopeB.value > phSlopeAboveRangeWarning
                    "
                    [warningMessage]="phSlopeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phOffsetBField"
                    [minValue]="phOffsetMin"
                    [maxValue]="phOffsetMax"
                    [step]="phOffsetStep"
                    [showWarning]="manualPHF.offsetB.value < phBelowRangeWarning"
                    [warningMessage]="phBelowRangeWarningMessage"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.Sparging) {
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="spargingSlopeBField"
                    [minValue]="spargingSlopeMin"
                    [maxValue]="spargingSlopeMax"
                    [step]="spargingSlopeStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="interceptBField"
                    [minValue]="spargingInterceptMin"
                    [maxValue]="spargingInterceptMax"
                    [step]="spargingInterceptStep"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType !== ModuleEnum.Oxygen) {
                  <p>R2: 1</p>
                }
              </div>
              <h6>Flask C</h6>
              <div class="manual-form-fields">
                @if (calibrationModuleType === ModuleEnum.BaseModule) {
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="offsetCField"
                    [minValue]="odOffsetMin"
                    [maxValue]="odOffsetMax"
                    [step]="odOffsetStep"
                    [showWarning]="manualODF.offsetC.value < odBelowRangeWarning"
                    [warningMessage]="odBelowRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="factorCField"
                    [minValue]="odFactorMin"
                    [maxValue]="odFactorMax"
                    [step]="odFactorStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="powerCField"
                    [minValue]="odPowerMin"
                    [maxValue]="odPowerMax"
                    [step]="odPowerStep"
                    [showWarning]="
                      manualODF.powerC.value > odPowerAboveRangeWarning
                    "
                    [warningMessage]="odPowerAboveRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="temperatureCField"
                    [minValue]="odTemperatureMin"
                    [maxValue]="odTemperatureMax"
                    [step]="odTemperatureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "100"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi100CField"
                    [minValue]="oxygenDphi100Min"
                    [maxValue]="oxygenDphi100Max"
                    [step]="oxygenDphi100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature100CField"
                    [minValue]="oxygenTemp100Min"
                    [maxValue]="oxygenTemp100Max"
                    [step]="oxygenTemp100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="pressure100CField"
                    [minValue]="oxygenPressureMin"
                    [maxValue]="oxygenPressureMax"
                    [step]="oxygenPressureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "0"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi0CField"
                    [minValue]="oxygenDphi0Min"
                    [maxValue]="oxygenDphi0Max"
                    [step]="oxygenDphi0Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature0CField"
                    [minValue]="oxygenTemp0Min"
                    [maxValue]="oxygenTemp0Max"
                    [step]="oxygenTemp0Step"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.pH) {
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phSlopeCField"
                    [minValue]="phSlopeMin"
                    [maxValue]="phSlopeMax"
                    [step]="phSlopeStep"
                    [showWarning]="
                      manualPHF.slopeC.value < phSlopeBelowRangeWarning ||
                      manualPHF.slopeC.value > phSlopeAboveRangeWarning
                    "
                    [warningMessage]="phSlopeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phOffsetCField"
                    [minValue]="phOffsetMin"
                    [maxValue]="phOffsetMax"
                    [step]="phOffsetStep"
                    [showWarning]="manualPHF.offsetC.value < phBelowRangeWarning"
                    [warningMessage]="phBelowRangeWarningMessage"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.Sparging) {
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="spargingSlopeCField"
                    [minValue]="spargingSlopeMin"
                    [maxValue]="spargingSlopeMax"
                    [step]="spargingSlopeStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="interceptCField"
                    [minValue]="spargingInterceptMin"
                    [maxValue]="spargingInterceptMax"
                    [step]="spargingInterceptStep"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType !== ModuleEnum.Oxygen) {
                  <p>R2: 1</p>
                }
              </div>
              <h6>Flask D</h6>
              <div class="manual-form-fields">
                @if (calibrationModuleType === ModuleEnum.BaseModule) {
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="offsetDField"
                    [minValue]="odOffsetMin"
                    [maxValue]="odOffsetMax"
                    [step]="odOffsetStep"
                    [showWarning]="manualODF.offsetD.value < odBelowRangeWarning"
                    [warningMessage]="odBelowRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="factorDField"
                    [minValue]="odFactorMin"
                    [maxValue]="odFactorMax"
                    [step]="odFactorStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="powerDField"
                    [minValue]="odPowerMin"
                    [maxValue]="odPowerMax"
                    [step]="odPowerStep"
                    [showWarning]="
                      manualODF.powerD.value > odPowerAboveRangeWarning
                    "
                    [warningMessage]="odPowerAboveRangeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualODCalibrationForm"
                    [field]="temperatureDField"
                    [minValue]="odTemperatureMin"
                    [maxValue]="odTemperatureMax"
                    [step]="odTemperatureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "100"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi100DField"
                    [minValue]="oxygenDphi100Min"
                    [maxValue]="oxygenDphi100Max"
                    [step]="oxygenDphi100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature100DField"
                    [minValue]="oxygenTemp100Min"
                    [maxValue]="oxygenTemp100Max"
                    [step]="oxygenTemp100Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="pressure100DField"
                    [minValue]="oxygenPressureMin"
                    [maxValue]="oxygenPressureMax"
                    [step]="oxygenPressureStep"
                  ></app-number-form-field>
                }
                @if (
                  calibrationModuleType === ModuleEnum.Oxygen &&
                  selectedTabOption === "0"
                ) {
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="dphi0DField"
                    [minValue]="oxygenDphi0Min"
                    [maxValue]="oxygenDphi0Max"
                    [step]="oxygenDphi0Step"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualOxygenCalibrationForm"
                    [field]="temperature0DField"
                    [minValue]="oxygenTemp0Min"
                    [maxValue]="oxygenTemp0Max"
                    [step]="oxygenTemp0Step"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.pH) {
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phSlopeDField"
                    [minValue]="phSlopeMin"
                    [maxValue]="phSlopeMax"
                    [step]="phSlopeStep"
                    [showWarning]="
                      manualPHF.slopeD.value < phSlopeBelowRangeWarning ||
                      manualPHF.slopeD.value > phSlopeAboveRangeWarning
                    "
                    [warningMessage]="phSlopeWarningMessage"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualPHCalibrationForm"
                    [field]="phOffsetDField"
                    [minValue]="phOffsetMin"
                    [maxValue]="phOffsetMax"
                    [step]="phOffsetStep"
                    [showWarning]="manualPHF.offsetD.value < phBelowRangeWarning"
                    [warningMessage]="phBelowRangeWarningMessage"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType === ModuleEnum.Sparging) {
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="spargingSlopeDField"
                    [minValue]="spargingSlopeMin"
                    [maxValue]="spargingSlopeMax"
                    [step]="spargingSlopeStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="manualSpargingCalibrationForm"
                    [field]="interceptDField"
                    [minValue]="spargingInterceptMin"
                    [maxValue]="spargingInterceptMax"
                    [step]="spargingInterceptStep"
                  ></app-number-form-field>
                }
                @if (calibrationModuleType !== ModuleEnum.Oxygen) {
                  <p>R2: 1</p>
                }
              </div>
            }
            <div id="notes--container">
              <app-underlined-textarea-field
                [parentForm]="calibrationForm"
                [field]="noteField"
                [minLength]="notesMinLength"
                [maxLength]="notesMaxLength"
                [rows]="4"
                [showCharacterCounter]="true"
              >
              </app-underlined-textarea-field>
            </div>
          </div>
        </div>
        @if (error) {
          <div id="error--container">
            <p class="error">Error: {{ error.message }}</p>
          </div>
        }
        <div id="button--container">
          @if (calibrationModuleType === ModuleEnum.BaseModule) {
            <app-button
              label="continue"
              buttonId="continue-btn"
              [isProcessing]="isProcessing"
              [isDisabled]="
                this.calibrationForm.invalid ||
                (!isManualCalibration &&
                  this.temperatureValuesForm.invalid) ||
                (isManualCalibration && this.manualODCalibrationForm.invalid)
              "
              (buttonClicked)="onSubmitCreateCalibrationForm()"
            ></app-button>
          }
          @if (calibrationModuleType === ModuleEnum.Oxygen) {
            <app-button
              label="continue"
              buttonId="continue-btn"
              [isProcessing]="isProcessing"
              [isDisabled]="
                this.calibrationForm.invalid ||
                (!isManualCalibration &&
                  this.temperatureValuesForm.invalid) ||
                (isManualCalibration &&
                  this.manualOxygenCalibrationForm.invalid)
              "
              (buttonClicked)="onSubmitCreateCalibrationForm()"
            ></app-button>
          }
          @if (calibrationModuleType === ModuleEnum.pH) {
            <app-button
              label="continue"
              buttonId="continue-btn"
              [isProcessing]="isProcessing"
              [isDisabled]="
                this.calibrationForm.invalid ||
                (!isManualCalibration && this.pHForm.invalid) ||
                (isManualCalibration && this.manualPHCalibrationForm.invalid)
              "
              (buttonClicked)="onSubmitCreateCalibrationForm()"
            ></app-button>
          }
          @if (calibrationModuleType === ModuleEnum.Sparging) {
            <app-button
              label="continue"
              buttonId="continue-btn"
              [isProcessing]="isProcessing"
              [isDisabled]="
                this.calibrationForm.invalid ||
                (!isManualCalibration && this.spargingForm.invalid) ||
                (isManualCalibration &&
                  this.manualSpargingCalibrationForm.invalid)
              "
              (buttonClicked)="onSubmitCreateCalibrationForm()"
            ></app-button>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
